import { reactive, nextTick } from 'vue'

export const pageNavigation = reactive({ visible: false, pending: false, error: '' })

export function installPageNavigation (router) {
  let activeRoute
  let hideTimer
  const finish = (success = true) => {
    pageNavigation.pending = false
    clearTimeout(hideTimer)
    if (success) hideTimer = setTimeout(() => { pageNavigation.visible = false }, 180)
    else pageNavigation.visible = false
  }
  router.beforeEach((to, from) => {
    activeRoute = to
    clearTimeout(hideTimer)
    pageNavigation.error = ''
    pageNavigation.visible = Boolean(from.matched.length && to.path !== from.path)
    pageNavigation.pending = pageNavigation.visible
  })
  router.afterEach((to, from, failure) => {
    if (to === activeRoute) finish(!failure)
  })
  router.onError((_error, to) => {
    if (to !== activeRoute) return
    finish(false)
    pageNavigation.error = 'Не удалось открыть страницу. Попробуйте перейти ещё раз.'
  })
}

export async function pageScrollBehavior (to, from, savedPosition) {
  if (savedPosition) return { ...savedPosition, behavior: 'instant' }
  if (to.hash) {
    await nextTick()
    let id
    try { id = decodeURIComponent(to.hash.slice(1)) } catch { id = to.hash.slice(1) }
    const element = document.getElementById(id)
    if (element) {
      const header = document.getElementById('header')
      const fixedHeader = header && ['fixed', 'sticky'].includes(getComputedStyle(header).position)
      return { el: element, top: fixedHeader ? header.offsetHeight + 16 : 16, behavior: 'instant' }
    }
  }
  // Filters and payment confirmation query cleanup keep the current position.
  if (to.path === from.path) return false
  return { left: 0, top: 0, behavior: 'instant' }
}
